module.exports = __webpack_public_path__ + "img/douyin4s.fc7a9768.png";